
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import Simplified_Chinese from '@/common/lang/Simplified_Chinese'
import Traditional_Chinese from '@/common/lang/Traditional_Chinese'
import English from '@/common/lang/English'
import Japanese from '@/common/lang/Japanese'
import Korean from '@/common/lang/Korean'

import sch from 'element-ui/lib/locale/lang/zh-CN'
import tch from 'element-ui/lib/locale/lang/zh-TW'
import en from 'element-ui/lib/locale/lang/en'
import ja from 'element-ui/lib/locale/lang/ja'
import ko from 'element-ui/lib/locale/lang/ko'

Vue.use(VueI18n)
const messages = {
  Simplified_Chinese: {
    ...Simplified_Chinese,
    ...sch
  }, // 简体中文
  Traditional_Chinese: {
    ...Traditional_Chinese,
    ...tch
  }, // 繁体中文
  English: {
    ...English,
    ...en
  }, // 英文
  Japanese: {
    ...Japanese,
    ...ja
  }, // 日文
  Korean: {
    ...Korean,
    ...ko
  } // 韩文
}

const i18n = new VueI18n({
  locale: localStorage.getItem('languageCode') || 'Simplified_Chinese',
  messages
})

locale.i18n((key, value) => i18n.t(key, value)) // 为了实现element插件的多语言切换

export default i18n
